import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { ABUtils } from '../../utils';

export const useRoomSelectorClassNames = (isOpen, hasError) => {
    const { isCssVariationDesktop } = ABUtils.getABs();
    const [css, setCss] = useState({});

    useEffect(() => setCss({
        arrow: classNames({
            'odf-input-icon odf-icon': true,
            'odf-icon-arrow-up odf-z-index-3': isOpen,
            'odf-icon-arrow-down': !isOpen,
        }),
        header: classNames({
            'focus odf-input-inline-focus': isOpen,
            'odf-input-group': true,
            'invalid': hasError,
        }),
        paxSelector: classNames({
            'odf-box odf-box-layer odf-space-inner-right-l odf-space-inner-left-l odf-popup odf-popup-flex opened': true,
            'odf-space-inner-left-l odf-space-inner-right-l': isCssVariationDesktop,
        }),
    }), [hasError, isCssVariationDesktop, isOpen]);

    return [css];
};

export const getAddRoomSelectorClassNames = (isMobile = true) => {
    const { isCssVariation, isCssVariationMobile } = ABUtils.getABs();

    return {
        wrapper: classNames({
            'odf-space-inner-top-m odf-space-inner-right-m odf-space-inner-left-m odf-box-content-md': !isCssVariation,
            'odf-space-inner-top-m': isCssVariation,
            'prisma-responsive-space-horizontal': isCssVariationMobile,
            'odf-space-inner-bottom-m': isCssVariation && isMobile,
            'odf-text-md': true,
        })
    };
};

export const getDeleteRoomSelectorClassNames = () => {
    const { isCssVariation, isCssVariationMobile } = ABUtils.getABs();

    return {
        wrapper: classNames({
            'odf-box-content odf-box-content-md': !isCssVariation,
            'odf-space-inner-top-m odf-space-inner-bottom-m': isCssVariation,
            'prisma-responsive-space-horizontal': isCssVariationMobile,
            'odf-strong': true,
        }),
        icon: classNames({
            'odf-space-inner-right-l': !isCssVariationMobile,
            'odf-space-inner-right-s': isCssVariationMobile,
            'odf-icon odf-icon-cross-light odf-icon-2xl odf-text-mono-color-05 odf-clickable dp-pax-selector-delete-room': true,
        })
    };
};
